/** Media query result is used within a hook that is already executed client-only; this is safe to use. */
// eslint-disable-next-line no-restricted-imports
import { useMobileMediaQuery } from '@iheartjane/reefer';
import { useEffect, useState } from 'react';

const MIN_KEYBOARD_HEIGHT = 250;

const detectKeyboard = () =>
  !!window.visualViewport &&
  window.screen.height - MIN_KEYBOARD_HEIGHT > window.visualViewport.height;

type UseDetectKeyboardArgs = {
  disableDetection?: boolean;
  interval?: number;
};

/**
 * This hook sets an interval to listen for the virtual keyboard
 * ideally, you could just listen for the VisualViewport 'resize' event
 * but it doesn't consistently work on all browsers, especially when
 * dealing with an embedded iframe (like in the case of the checkout)
 */
export const useDetectKeyboard = ({
  disableDetection,
  interval = 200,
}: UseDetectKeyboardArgs) => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const isMobile = useMobileMediaQuery({});

  useEffect(() => {
    if (disableDetection) {
      return;
    }
    const detectionInterval = setInterval(() => {
      const keyboardDetected = isMobile && detectKeyboard();
      if (keyboardDetected !== isKeyboardOpen) {
        setIsKeyboardOpen(keyboardDetected);
      }
    }, interval);
    return () => clearInterval(detectionInterval);
  }, [disableDetection, interval, isKeyboardOpen, isMobile, setIsKeyboardOpen]);

  return isKeyboardOpen;
};
